import { createApp } from 'vue';
import CusConfirm from '@/library/CusConfirm.vue';

let confirmDom;

const useConfirm = (props) => {
  return new Promise((resolve, reject) => {
    const dialog = document.querySelector('#confirm-dialog');
    if (dialog) dialog.remove();
    confirmDom = createApp(CusConfirm).mount(document.createElement('div'));
    props.type = 'confirm';
    if (!props.title) props.title = '確認';
    confirmDom.props = Object.assign({}, confirmDom.props, props);
    document.body.appendChild(confirmDom.$el);
    const confirmDialog = document.querySelector('#confirm-dialog');
    confirmDom.confirm = function () {
      confirmDom.confirmVisible = false;
      resolve(props.confirmText);
      setTimeout(() => {
        confirmDialog.remove();
      }, 500);
    };
    confirmDom.confirm2 = function () {
      confirmDom.confirmVisible = false;
      resolve(props.confirm2Text);
      setTimeout(() => {
        confirmDialog.remove();
      }, 500);
    };
    confirmDom.cancel = function () {
      confirmDom.confirmVisible = false;
      reject('取消');
      setTimeout(() => {
        confirmDialog.remove();
      }, 500);
    };
  });
};

const useMessage = (title, content, obj) => {
  return new Promise((resolve, reject) => {
    const dialog = document.querySelector('#confirm-dialog');
    if (dialog) dialog.remove();
    confirmDom = createApp(CusConfirm).mount(document.createElement('div'));
    const props = {
      type: 'message',
      title,
      content,
      confirmText: '關閉',
      ...obj,
    };
    confirmDom.props = Object.assign({}, confirmDom.props, props);
    document.body.appendChild(confirmDom.$el);
    const confirmDialog = document.querySelector('#confirm-dialog');
    confirmDom.close = function () {
      confirmDom.confirmVisible = false;
      resolve('關閉');
      setTimeout(() => {
        confirmDialog.remove();
      }, 500);
    };
    confirmDom.confirm = function () {
      confirmDom.confirmVisible = false;
      resolve('確認並關閉');
      setTimeout(() => {
        confirmDialog.remove();
      }, 500);
    };
    confirmDom.cancel = function () {
      confirmDom.confirmVisible = false;
      reject('取消');
      setTimeout(() => {
        confirmDialog.remove();
      }, 500);
    };
  });
};

export { useConfirm, useMessage };
